import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';

export type SubmitButtonProps = ButtonProps<any & typeof motion> & {
  loading?: boolean;
};

export const SubmitButton = ({
  loading,
  disabled,
  endIcon,
  ...props
}: SubmitButtonProps) => (
  <Button
    fullWidth
    type="submit"
    component={motion.button}
    layout="position"
    disabled={loading || disabled}
    endIcon={
      loading ? (
        <CircularProgress color="inherit" size={16} thickness={4} />
      ) : (
        endIcon ?? <div />
      )
    }
    {...props}
    sx={{
      mb: 2,
      ...props.sx
    }}
  />
);
